import { Box, Typography, Button, type SxProps } from '@mui/material'
import type { ReactNode } from 'react'

interface EmptyStateProps {
    icon?: ReactNode
    title: string
    description?: string
    actionLabel?: string
    onAction?: () => void
    /** Custom action element (takes precedence over actionLabel/onAction) */
    action?: ReactNode
    sx?: SxProps
}

export function EmptyState({
    icon,
    title,
    description,
    actionLabel,
    onAction,
    action,
    sx,
}: EmptyStateProps) {
    return (
        <Box sx={{ textAlign: 'center', py: 8, ...sx }}>
            {icon && (
                <Box sx={{ mb: 2, color: 'text.secondary', '& > svg': { fontSize: 48 } }}>
                    {icon}
                </Box>
            )}
            <Typography variant="h6" gutterBottom>
                {title}
            </Typography>
            {description && (
                <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 420, mx: 'auto' }}>
                    {description}
                </Typography>
            )}
            {action ? (
                <Box>{action}</Box>
            ) : (
                actionLabel &&
                onAction && (
                    <Button variant="contained" onClick={onAction}>
                        {actionLabel}
                    </Button>
                )
            )}
        </Box>
    )
}
